import React__default from 'react';

const AkCheckCircleOutlineIcon = () => {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M12 20c2.1217 0 4.1566-.8429 5.6569-2.3431C19.1571 16.1566 20 14.1217 20 12c0-2.12173-.8429-4.15656-2.3431-5.65685C16.1566 4.84285 14.1217 4 12 4c-2.12173 0-4.15656.84285-5.65685 2.34315C4.84285 7.84344 4 9.87827 4 12c0 2.1217.84285 4.1566 2.34315 5.6569C7.84344 19.1571 9.87827 20 12 20Zm0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.707 11.293c-.09225-.0955-.20259-.1717-.3246-.2241-.122-.0524-.25322-.08-.386-.0812-.13278-.0011-.26446.0242-.38735.0745-.1229.0503-.23455.1245-.32844.2184-.0939.0939-.16815.2055-.21843.3284-.05028.1229-.07558.2546-.07443.3874.00115.1328.02874.264.08115.386s.12859.2324.2241.3246l2 2c.1875.1875.4418.2928.707.2928.2652 0 .5195-.1053.707-.2928l4-4c.0955-.0922.1717-.2026.2241-.3246s.08-.2532.0812-.386c.0011-.13278-.0242-.26446-.0745-.38735-.0503-.1229-.1245-.23455-.2184-.32845-.0939-.09389-.2055-.16814-.3284-.21842-.1229-.05028-.2546-.07559-.3874-.07443-.1328.00115-.264.02874-.386.08115s-.2324.12859-.3246.2241L11 12.586l-1.293-1.293Z",
    fill: "currentColor"
  }));
};
AkCheckCircleOutlineIcon.displayName = "AkCheckCircleOutlineIcon";
const AkWarningIcon = () => {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.062 4.967c.516-.974 1.358-.978 1.876 0l7.124 13.458c.516.974.045 1.771-1.057 1.771H4.995c-1.102 0-1.575-.793-1.057-1.771l7.124-13.458Zm.2309 9.7401c.1875.1875.4419.2929.7071.2929.2652 0 .5196-.1054.7071-.2929S13 14.2652 13 14V9c0-.26522-.1054-.51957-.2929-.70711C12.5196 8.10536 12.2652 8 12 8c-.2652 0-.5196.10536-.7071.29289C11.1054 8.48043 11 8.73478 11 9v5c0 .2652.1054.5196.2929.7071Zm0 3c.1875.1875.4419.2929.7071.2929.2652 0 .5196-.1054.7071-.2929S13 17.2652 13 17c0-.2652-.1054-.5196-.2929-.7071S12.2652 16 12 16c-.2652 0-.5196.1054-.7071.2929S11 16.7348 11 17c0 .2652.1054.5196.2929.7071Z",
    fill: "currentColor"
  }));
};
AkWarningIcon.displayName = "AkWarningIcon";
const AkErrorIcon = () => {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7664 3.98276c.2429.10067.4637.24823.6496.43425l6.168 6.16699c.1862.1859.3338.4067.4346.6498.1008.2431.1526.5036.1526.7667s-.0518.5237-.1526.7667c-.1008.2431-.2484.4639-.4346.6498l-6.168 6.167c-.1859.186-.4067.3336-.6496.4343-.243.1006-.5034.1524-.7664.1524s-.5234-.0518-.7664-.1524c-.2429-.1007-.4637-.2483-.6496-.4343l-6.168-6.167c-.18617-.1859-.33386-.4067-.43462-.6498-.10076-.243-.15263-.5036-.15263-.7667s.05187-.5236.15263-.7667c.10076-.2431.24845-.4639.43462-.6498l6.168-6.16699c.1859-.18602.4067-.33358.6496-.43425.243-.10068.5034-.1525.7664-.1525s.5234.05182.7664.1525Zm-1.4735 9.72434c.1875.1875.4419.2929.7071.2929.2652 0 .5196-.1054.7071-.2929S13 13.2652 13 13V8c0-.26522-.1054-.51957-.2929-.70711C12.5196 7.10536 12.2652 7 12 7c-.2652 0-.5196.10536-.7071.29289C11.1053 7.48043 11 7.73478 11 8v5c0 .2652.1053.5196.2929.7071Zm0 3c.1875.1875.4419.2929.7071.2929.2652 0 .5196-.1054.7071-.2929S13 16.2652 13 16c0-.2652-.1054-.5196-.2929-.7071S12.2652 15 12 15c-.2652 0-.5196.1054-.7071.2929-.1876.1875-.2929.4419-.2929.7071 0 .2652.1053.5196.2929.7071Z",
    fill: "currentColor"
  }));
};
AkErrorIcon.displayName = "AkErrorIcon";

export { AkCheckCircleOutlineIcon, AkErrorIcon, AkWarningIcon };
